import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, animate = true }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          {...(animate
            ? { animate: { y: 0 } }
            : { whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } })}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.13 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const FadeIn = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs tracking-[0.25em] uppercase font-medium text-primary ${className}`}>
    {children}
  </span>
);
